import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsForProfitCompanyTypeEqualTo,
  IsApplicationSolar,
} from '../rules';
import { FOR_PROFIT_COMPANY_TYPES } from '../../../../../../../constants';

class PowerTaxEquityPartneringRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (!IsApplicationSolar.evaluate(data)) return RulesetResult.HIDDEN;
    if (
      IsForProfitCompanyTypeEqualTo.setCompanyType(
        FOR_PROFIT_COMPANY_TYPES.SELLS_SOLAR_GENERATED_POWER_TO_THIRD_PARTIES
      ).evaluate(data)
    )
      return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new PowerTaxEquityPartneringRuleset();
